import Axios from 'axios';

export default {
  getMenu: moduleId => Axios.post('Menu/GetMenu', moduleId),
  getSuspendedMenu: params => Axios.post('Menu/GetSuspendedMenu', params)
};
